import {
  ActionList,
  ActionListItem,
  Divider,
  GridItem,
  Link,
  Text,
} from "@certn/cascadia-react";
import { formatDate } from "@certn/utils";
import React from "react";
import { Trans } from "react-i18next";

import { ConvictionModal } from "./ConvictionModal";
import { Conviction } from "./type";

type ConvictionsListProps = {
  convictions: Conviction[];
  onSave: (conviction: Conviction) => void;
  onDelete: (index: number) => void;
  testID?: string;
};

export function ConvictionsList({
  convictions,
  onSave,
  onDelete,
  testID,
}: ConvictionsListProps) {
  return (
    <GridItem>
      <ActionList testID={testID}>
        {convictions.map((conviction, i) => (
          <React.Fragment key={i}>
            <ActionListItem
              title={conviction.description ?? "-"}
              trailing={
                <ConvictionModal
                  index={i}
                  conviction={conviction}
                  onSave={onSave}
                  onDelete={() => onDelete(i)}
                  trigger={
                    <Link
                      linkStyle="monochrome"
                      textStyle="global/body-secondary"
                      testID="personal-history-conviction-index-edit-button"
                    >
                      <Trans>Edit</Trans>
                    </Link>
                  }
                />
              }
            >
              <Text style="global/body-secondary" color="text-weak">
                {formatDate(
                  conviction.date_of_sentence,
                  "MMMM dd, yyyy"
                ).toString()}
              </Text>
            </ActionListItem>
            <Divider />
          </React.Fragment>
        ))}
      </ActionList>
    </GridItem>
  );
}
